export default function padWithZeros(inputString: string, length: number = 8) {
  // Convert the input to a string (in case it's not already)
  const str = String(inputString);

  // Use padStart method to pad the string with leading zeros until it reaches length 8
  return str.padStart(length, '0');
}
